import { render, staticRenderFns } from "./mobileDeclination1.vue?vue&type=template&id=4c40f653&scoped=true&"
import script from "./mobileDeclination1.vue?vue&type=script&lang=ts&"
export * from "./mobileDeclination1.vue?vue&type=script&lang=ts&"
import style0 from "./mobileDeclination1.vue?vue&type=style&index=0&id=4c40f653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40f653",
  null
  
)

export default component.exports